import React, { useState } from "react";
import Gen from "./generate";

function Card() {
  const [activeTab, setActiveTab] = useState("generate");
  const [formData, setFormData] = useState({
    name: "",
    faculty: "",
    department: "",
    class: "",
    matricule: "",
    year: "",
  });
  const [uploadedFile, setUploadedFile] = useState(null);
  const [students, setStudents] = useState([]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const newFileName = `${formData.name.replace(/\s+/g, "_")}.png`;
      const renamedFile = new File([file], newFileName, { type: file.type });
      setUploadedFile(renamedFile);
    }
  };

  const saveFile = (file, filePath) => {
    const reader = new FileReader();
    reader.onload = () => {
      const blob = new Blob([reader.result], { type: file.type });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = filePath.split("/").pop();
      a.click();
      console.log(`File saved at: ${filePath}`);
    };
    reader.readAsArrayBuffer(file);
  };

    return (
    <div className="card_section">
      <div>
        <button
          className={activeTab === "generate" ? "m-tab active" : "m-tab"}
          onClick={() => setActiveTab("generate")}
        >
          Générer
        </button>
        <button
        id="view_tab"
          className={activeTab === "view" ? "m-tab active" : "m-tab"}
          onClick={() => setActiveTab("view")}
        >
          Apperçu
        </button>
        <div className="m-tab-content">
          {activeTab === "generate" && (
            <div className="content-form">
              <Gen/>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Card;
